import { routes } from '../../constants';

export const links = [
  {
    href: routes.home,
    labelKey: 'navigationBar.home',
  },
  // TODO: This will be needed in the future
  // {
  //   href: routes.huddVsTheOthers,
  //   labelKey: 'navigationBar.huddVsTheOthers',
  // },
  {
    href: routes.home,
    labelKey: 'navigationBar.faq',
    sectionId: 'faq',
  },
];
